// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "redirectButton_success-3TTSM";
export { _1 as "__esModule", _2 as "redirectButton_success" }
export default { "__esModule": _1, "redirectButton_success": _2 }
